import { useContext, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import ModalTambahStaf from "../components/ModalTambahStaf";
import ModalDeleteStaff from "../components/ModalDelete";
// import deleteStaf from "../services/deleteStaf";
import ModalDetailStaf from "../components/ModalDetailStaf";
import ModalCuti from "../components/ModalCuti";
import ModalAbsen from "../components/ModalAbsen";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useStaf } from "../../../Context/StafContext";

const Operasi = ({ row, refreshStaff }) => {
  const stafAPI = useStaf();
  const { checkPermission } = useContext(RoleContext);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [cutiOpen, setCutiOpen] = useState(null);
  const [AbsenOpen, setAbsenOpen] = useState(null);
  const [updateOpen, setUpdateOpen] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);

  const toggleDropdown = (id) =>
    setDropdownOpen(dropdownOpen === id ? null : id);
  const toggleCuti = (id) => setCutiOpen(cutiOpen === id ? null : id);
  const toggleAbsen = (id) => setAbsenOpen(AbsenOpen === id ? null : id);
  const toggleUpdate = (id) => setUpdateOpen(updateOpen === id ? null : id);
  const toggleDelete = (id) => setDeleteOpen(deleteOpen === id ? null : id);

  return (
    <div>
      <Dropdown
        toggle={() => toggleDropdown(row?.id)}
        isOpen={dropdownOpen === row?.id}
      >
        <DropdownToggle>&#9660;</DropdownToggle>
        <DropdownMenu>
          {checkPermission(PERMISSIONS.ADD_CUTI) && (
            <DropdownItem style={{color: '#000'}} onClick={() => toggleCuti(row?.id)}>
              Cuti
            </DropdownItem>
          )}
          {checkPermission(PERMISSIONS.ADD_ABSENSI) && (
            <DropdownItem style={{color: '#000'}} onClick={() => toggleAbsen(row?.id)}>
              Absen
            </DropdownItem>
          )}
          {checkPermission(PERMISSIONS.CHANGE_STAF) && (
            <DropdownItem style={{color: '#000'}} onClick={() => toggleUpdate(row?.id)}>
              Update
            </DropdownItem>
          )}
          {checkPermission(PERMISSIONS.DELETE_STAF) && (
            <DropdownItem style={{color: '#000'}} onClick={() => toggleDelete(row?.id)}>
              Delete
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
      <ModalAbsen
        resetState={refreshStaff}
        toggle={() => toggleAbsen(row.username)}
        data={row}
        isOpen={AbsenOpen === row?.id}
      />
      <ModalCuti
        resetState={refreshStaff}
        toggle={() => toggleCuti(row.username)}
        data={row}
        isOpen={cutiOpen === row?.id}
      />
      <ModalTambahStaf
        create={false}
        staf={row}
        resetState={refreshStaff}
        toggle={() => toggleUpdate(row.id)}
        isOpen={updateOpen === row?.id}
      />
      <ModalDeleteStaff
        name={row?.nama}
        axiosDelete={stafAPI}
        pk={row?.id}
        resetState={refreshStaff}
        toggle={() => toggleDelete(row.id)}
        isOpen={deleteOpen === row?.id}
      />
    </div>
  );
};

const StafColumns = (refreshStaff, stafList) => {
  return [
    {
      name: <DataTableTitle text={"Grup"} />,
      selector: (row) => row?.group_nama,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Nama Staff"} />,
      cell: (row) => <ModalDetailStaf row={row} stafList={stafList} />,
    },
    {
      name: <DataTableTitle text={"NIP"} />,
      selector: (row) => row?.nip,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"NUP UI"} />,
      selector: (row) => row?.nup_ui,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Username"} />,
      selector: (row) => row?.username_ldap,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Ruang"} />,
      selector: (row) => row?.ruangan,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Ext Telp"} />,
      selector: (row) => row?.ext_telp,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Telp"} />,
      selector: (row) => row?.telp,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => {
        return <Operasi row={row} refreshStaff={refreshStaff} />;
      },
    },
  ];
};

export default StafColumns;
